import { Controller } from "stimulus";
import Swal from "sweetalert2";
import FormSimulate from "../entrypoints/src/admin/components/form_simulate";

// Rendered (via turbo_stream) when "Enviar Cobrança" hits the same-day dedup guard.
// Fires a confirmation dialog and, if the user confirms, re-POSTs the send action with
// force=true to dispatch a duplicate notification on purpose.
export default class extends Controller {
  static values = { url: String, text: String };

  connect() {
    Swal.fire({
      icon: "warning",
      title: "Cliente já notificado hoje",
      html: this.textValue,
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: "Enviar mesmo assim",
      cancelButtonText: "Cancelar",
      customClass: {
        cancelButton: "btn btn-gray-primary mx-2",
        confirmButton: "btn btn-primary mx-2"
      }
    }).then((result) => {
      const confirmed = result.isConfirmed;
      this.element.remove();

      if (confirmed) this.resend();
    });
  }

  resend() {
    FormSimulate.submit({
      method: "post",
      action: this.urlValue,
      turbo: true,
      turboStream: true
    });
  }
}
